<template>
  <div>
    <h1>【{{ obj.name }}】测试步骤设置</h1>
   
    <div>
      <el-button
        type="primary"
        icon="el-icon-plus"
        circle
        @click="addTestStep"
        title="增加测试用例步骤"
      ></el-button>
      <!-- <el-button
        type="success"
        icon="el-icon-video-play"
        circle
        
        title="执行当前测试用例"
      ></el-button> -->
      <el-button
        type="warning"
        icon="el-icon-video-camera-solid"
        circle
        title="查看执行日志"
      ></el-button>
    </div>
    <el-table :data="tableData" stripe style="width: 100%">
       <el-table-column prop="sort" label="排序"> </el-table-column>
      <el-table-column prop="name" label="步骤名称"> </el-table-column>
      <el-table-column prop="operation" label="操作方式"> </el-table-column>
      <el-table-column prop="value" label="输入值"> </el-table-column>
      <el-table-column prop="path" label="元素位置"> </el-table-column>
      <el-table-column prop="findWay" label="查找方式"> </el-table-column>
      <el-table-column prop="delay" label="是否延时操作"> </el-table-column>
      <el-table-column prop="token" label="token操作"> </el-table-column>
      <el-table-column prop="expect" label="期望"> </el-table-column>
      <el-table-column prop="remark" label="备注信息"> </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="queryById(scope.row.id)"
            >编辑</el-button
          >
          <el-button type="text" size="small" @click="deleteById(scope.row.id)"
            >删除</el-button
          >
          <el-button type="text" size="small" @click="moveUp(scope.row,scope.$index)"
            >上移</el-button
          >
          <el-button type="text" size="small" @click="moveDown(scope.row,scope.$index)"
            >下移</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <el-dialog
      width="80%"
      title="添加测试用例信息"
      :visible.sync="dialogFormVisible"
    >
      <el-form label-position="right" label-width="80px">
        <el-form-item label="用例名称">
          <el-col :span="15">
            <el-input v-model="steps.name"></el-input>
          </el-col>
        </el-form-item>

        <el-form-item label="操作方式">
          <el-col :span="15">
            <el-select
              @change="selectChange"
              v-model="steps.operation"
              placeholder="请选择环境..."
              style="margin-right: 20px"
            >
              <el-option
                v-for="item in envs"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-col>
        </el-form-item>
        <el-form-item label="输入方式">
          <el-col :span="15">
            <el-radio-group v-model="steps.isMuti" @change="radioChange">
              <el-radio :label="0">单个操作</el-radio>
              <el-radio :label="1">批量操作</el-radio>
            </el-radio-group>
          </el-col>
        </el-form-item>
        <el-form-item label="输入值" v-if="steps.isMuti==0 ">
          <el-col :span="15">
            <el-input
              v-model="steps.value"
              placeholder="如果是非输入值场景，可以选择留空..."
            ></el-input>
          </el-col>
        </el-form-item>

        <el-form-item v-for="(item,index) in steps.mutiContent" :key="index" :label="(index>0)?'':'输入值:'" v-if="steps.isMuti==1">
          <el-col :span="10">
            <el-input v-model="steps.mutiContent[index].path" placeholder="请输入元素定位路径..."  >
            <el-select v-model="steps.mutiContent[index].findWay" slot="prepend" placeholder="请选择" style="width:160px;">
              <el-option
                v-for="item in findWays"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>  
            <!-- <el-button slot="append" icon="el-icon-search"></el-button> -->
          </el-input>
          </el-col>
          <el-col :span="5" style="margin-left:10px;">
           <el-input v-model="steps.mutiContent[index].value" placeholder="请设定输入值..." />
           <!-- <el-select v-model="steps.findWay" slot="prepend" placeholder="请选择" style="width:160px;">
              <el-option
                v-for="item in findWays"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>   -->
          </el-col>
          <el-col :span="5" style="margin-left:10px;">
           <el-input v-model="steps.mutiContent[index].delay" placeholder="请设定延时时间,单位为秒，默认为0"  />
          </el-col>
          <el-col :span="3" style="margin-left:10px;" v-if="index==0">
            <el-tooltip class="item" effect="dark" content="点击我新增批量输入框" placement="right-start">
              <el-button type="success" icon="el-icon-plus" circle @click="addMutiInput"></el-button>
            </el-tooltip>
          </el-col>
          <el-col :span="3" style="margin-left:10px;" v-if="index>0">
            <el-tooltip class="item" effect="dark" content="点击我删除输入框" placement="right-start">
              <el-button type="error" icon="el-icon-minus" circle @click="deleteMutiInput(index)"></el-button>
            </el-tooltip>
          </el-col>
        </el-form-item>

        <el-form-item label="查找方式" v-if="steps.isMuti==0 && steps.operation!='view'">
          <el-col :span="5">
            <el-select v-model="steps.findWay" style="margin-right: 20px">
              <el-option
                v-for="item in findWays"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-col>
        </el-form-item>

        <el-form-item label="元素定位" v-if="steps.isMuti==0 && steps.operation!='view'">
          <el-col :span="15">
            <el-input v-model="steps.path"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="延时(秒)" v-if="steps.isMuti==0">
          <el-col :span="15">
            <el-input v-model="steps.delay"></el-input>
          </el-col>
        </el-form-item>

        <el-form-item label="期望值">
          <el-col :span="15">
            <el-input v-model="steps.expect"></el-input>
          </el-col>
        </el-form-item>

        <el-form-item label="排序">
          <el-col :span="15">
            <el-input v-model="steps.sort"></el-input>
          </el-col>
        </el-form-item>

        <el-form-item label="备注信息">
          <el-col :span="15">
            <el-input v-model="steps.remark" type="textarea"></el-input>
          </el-col>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="doSaveTestStep">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

  <script>
import TableCompnent from "@/components/table/TablesComponents";
import SysAutoTestStepApi from "@/api/SysAutoTestStepApi";
export default {
  name: "setStepList",
  props: {
    msg: String,
  },
  components: {
    TableCompnent,
  },
  data() {
    return {
      obj: {},
      dialogFormVisible: false,
      envs: [
        {
          value: "view",
          label: "打开网址",
        },
        {
          value: "input",
          label: "输入",
        },
        {
          value: "click",
          label: "点击",
        },
      ],
      findWays: [
        {
          value: "byId",
          label: "根据ID查找",
        },
        {
          value: "byClass",
          label: "根据class查找",
        },
        {
          value: "byXpath",
          label: "根据Xpath查找",
        },
      ],
      steps: {
        name: "",
        operation: "view",
        objId: 0,
        value: "",
        findWay: "byId",
        path: "",
        remark: "",
        expect: "",
        delay: 0,
        isMuti:0,
        sort:"",
        mutiContent:[
          {"findWay":"byId","path":"","value":"","delay":3}
        ]
      },
      search: {
        objId: 0,
        pageSize: 1000,
        pageNum: 1,
      },
      tableData: [],
    };
  },
  mounted() {
    this.obj = this.$route.params.obj;
    this.steps.objId = this.obj.id;
    this.search.objId = this.obj.id;
    this.querySteps();
  },
  methods: {
    querySteps() {
      SysAutoTestStepApi.search(this.search).then((resp) => {
        if (resp.state == "OK") {
          this.tableData = resp.data.records;
        }
      });
    },
    addTestStep() {
      this.dialogFormVisible = true;
      this.steps ={
        name: "",
        operation: "view",
        objId: this.obj.id,
        value: "",
        findWay: "byId",
        path: "",
        remark: "",
        expect: "",
        delay: 0,
        isMuti:0,
        mutiContent:[
          {"findWay":"byId","path":"","value":"","delay":3}
        ]
      }
    },
    doSaveTestStep(){
      this.steps.id > 0
        ? this.updateSysAutoTestStepById()
        : this.addSysAutoTestStep();
    },
    addSysAutoTestStep() {
      SysAutoTestStepApi.saveSysAutoTestStep(this.steps).then(
        (resp) => {
          if (resp.state == "OK") {
            this.steps = {};
            this.steps.objId = this.obj.id;
            this.$successMsg(resp.msg);
            this.dialogFormVisible = false;
            this.querySteps();
            
          } else {
            this.$errorMsg(resp.msg);
          }
        }
      );
    },
    updateSysAutoTestStepById() {
      SysAutoTestStepApi.updateSysAutoTestStep(this.steps).then(
        (resp) => {
          if (resp.state == "OK") {
            this.$successMsg(resp.msg);
            this.dialogFormVisible = false;
            this.querySteps();
            this.steps = {};
            this.steps.objId = this.obj.id;
            
          } else {
            this.$errorMsg(resp.msg);
          }
        }
      );
    },
    queryById(id) {
      SysAutoTestStepApi.querySysAutoTestStepById({ id }).then((resp) => {
        if (resp.state == "OK") {
          this.steps = resp.data;
          if(this.steps.mutiContent.length==0){
            this.steps.mutiContent=[
              {"findWay":"byId","path":"","value":"","delay":3}
            ]
          }
          this.dialogFormVisible = true;
        }
      });
    },
    deleteById(id) {
      SysAutoTestStepApi.deleteSysAutoTestStep({ id }).then((resp) => {
        if (resp.state == "OK") {
          this.querySteps();
        } else {
          this.$errorMsg(resp.msg);
        }
      });
    },
    selectChange(item){
      if(item=='view'){
        this.steps.isMuti=0;
      }
    },
    radioChange(item){
      if(this.steps.operation=='view' && item=='1'){
        this.$errorMsg("当前操作行为是【打开网址】操作，只允许进行单个元素操作");
        this.steps.isMuti=0
      }
    },
    addMutiInput(){
      let item ={"findWay":"byId","path":"","value":"","delay":3}
      this.steps.mutiContent.push(item)
      // this.$errorMsg("功能开发中，请暂时使用单个操作模式，新功能敬请期待...");
    },
    deleteMutiInput(index){
        this.$confirmDialog("当元素删除后，将无法进行恢复!!请确认后再进行操作",()=>{
          this.steps.mutiContent.splice(index,1)
        })
    },
    moveUp(current,index){
      if(index==0){
        this.$errorMsg("当前元素为第一个元素，无法进行上移操作");
        return
      }
      let neighbour = this.tableData[index-1];
      let params = {
        currentId:current.id,
        currentSort:current.sort,
        neighbourId:neighbour.id,
        neighbourSort:neighbour.sort,
      }
      SysAutoTestStepApi.moveUp(params).then((resp) => {
        if (resp.state == "OK") {
          this.$successMsg(resp.msg);
          this.querySteps()
        }
      });
    },
    moveDown(current,index){
       if((index+1)==this.tableData.length){
        this.$errorMsg("当前元素为最后一个元素，无法进行下移操作");
        return
      }
      let neighbour = this.tableData[index+1];
      let params = {
        currentId:current.id,
        currentSort:current.sort,
        neighbourId:neighbour.id,
        neighbourSort:neighbour.sort,
      }
      SysAutoTestStepApi.moveDown(params).then((resp) => {
        if (resp.state == "OK") {
          this.$successMsg(resp.msg);
          this.querySteps()
        }
      });
    }

  },
};
</script>